import StatusIcon from './StatusIcon';

export default StatusIcon;